// Placeholder icons per game-data category (see docs/icon-wishlist.md). Unknown categories get a note.
const ICONS: Record<string, string> = {
  items: 'chest',
  equipment: 'interactable',
  mob_stats: 'mob-spawn-point',
  mobs: 'mob-spawn-area',
  loot_tables: 'chest',
  quests: 'quest',
  dialogue: 'npc',
  merchants: 'npc',
  spells: 'altar',
  spell_effects: 'altar',
  altar_effects: 'altar',
  classes: 'player-start',
  recipes: 'resource',
  factions: 'zone',
};

export function categoryIcon(category: string): string {
  return ICONS[category] ?? 'note';
}
